// @flow

// Name
export const MODEL = 'reopenJob'

// Api End Point
export const URL = '/soilsampling/job/'

// State Configuration
export const TREE = 'soilJobsModule'
export const BRANCH = 'reopenJobOperations'
